// @flow

const url: any = window.URL || window.webkitURL || window.mozURL

export default url
